<template>
  <div>
    <!--Page Header-->
    <div class="row no-gutters mb-3">
      <!-- <div class="col-12 display-1 my-auto">Training Videos</div> -->
      <div class="col-12 mb-3">
        <div class="mr-md-4 pb-3 rounded shadow-sm">
            <div class="col-head py-2 px-3 rounded-top text-white">{{ getVideoName() }}</div>
            <div id="user_section" class="px-3 my-2">
            <video width="800" height="600" controls>
            <source :src="getVideoNamePath()" type="video/mp4">
            Your browser does not support the video tag.
            </video>
        </div>
        </div>
    </div>
    </div>
    <!--Tabbed Content-->
    <div class="mt-2 mb-4">
      <div>
      </div>
    </div>
  </div>
</template>


<script>
/* eslint-disable */

export default {
  data() {
    return {
    };
  },
  components: {
  },
  methods: {
    /** return selected video name */
    getVideoName() {
        const trainingVFile = sessionStorage.getItem('currentTrainingName');
        return trainingVFile;
    },
     /** return selected video path */
    getVideoNamePath() {
        const trainingVFile = sessionStorage.getItem('currentTraining');
        return trainingVFile;
    }
    
  },
  created() {
  },
  computed: {
  
  },
  mounted() {
  },
};
</script>

<style lang="scss">
#user_section {
  .vbt-autcomplete-list {
    padding-top: 0 !important;
  }

  .list-group-item:first-child {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
}
</style>

<style scoped>
.btn-outline-secondary {
    color: #595959;
    border-color: #595959;
} 
  .btn-outline-secondary:hover {
    color: #fff;
    border-color: #595959;
    background-color: #595959;
  }
.btn-outline-secondary:focus {
  box-shadow:  0 0 0.2rem rgba(51, 51, 51, .45);
  -webkit-box-shadow: 0 0 0.2rem rgba(51, 51, 51, .45);
}
/**TAB PANE STYLING**/
.tab-content .tab-pane{
  padding: 0;
  outline: none;
}

/**COLUMN STYLING**/
.col-head {
  background-color: #00162B;
}

/**FORM STYLING**/
/**Extra large devices (large desktops, 1200px and up)**/

#wrapper-input-product-filter {
  margin-top: 1rem;
}
.appointed-carriers-tab {	
  margin-top: 1rem;	
}	
#no-carriers-message {	
  display: flex;	
  height:300px;	
  justify-content: center;	
  align-items: center;	
  font-size:2rem;	
}
</style>
<style>
/**TAB NAV STYLING**/
.nav-tabs{
  border-bottom: 2px solid #003366;
}
  .nav-tabs .nav-link{
    color: #003366;
  }
  .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link{
    color: #FFFFFF;
    background-color: #003366;
    border-color: #003366 #003366 #003366;
  }
    .nav-tabs .nav-link:hover{
      border-color: #003366 #003366 #003366;
    }
    .nav-tabs .nav-link.active{
      background-color: #003366 !important;
      border-color: #003366 #003366 #003366 !important;
    }
    .nav-tabs .nav-link.disabled{
      color: #CCCCCC;
      border: none;
    }
.tab-content {
  border: none !important;
}

/**FORM STYLING**/
/**Side-by-Side fields**/
form .form-group.float-left {
  width: auto !important;
}
.tooltip-inner {
  max-width:600px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/VideoDetail.vue?5f3f6bd8